import axios from "axios";
import { config_headers, servicelist, URL_API } from "../Config";

export const pContractorReport2_Info = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            await axios.post(URL_API(`${servicelist.contractorService}p_contractor_report_2_info`), body, authorization).then((res) => {
                resolve(res.data);
            });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};

export const pContractorReport2_Update = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            await axios.post(URL_API(`${servicelist.contractorService}p_contractor_report_2_update`), body, authorization).then((res) => {
                resolve(res.data);
            });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};

export const getipAddress = async () => {
    return new Promise(async (resolve, reject) => {
        try {
            await axios.get("https://geolocation-db.com/json/").then((res) => {
                resolve(res.data.IPv4);
            });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};
